import React from 'react';

import { AsyncActionIcon } from '~components';
import { faSignature } from '~components/icon';

import { usePrintBudgetsToSign } from './usePrintBudgetsToSign';

interface ComponentProps {
  id: string;
}

const PrintBudgetToSign: React.FC<ComponentProps> = ({ id }) => {
  const { printToSign, isPrinting } = usePrintBudgetsToSign();

  return (
    <AsyncActionIcon
      id={`${id}-print-to-sign`}
      icon={faSignature}
      toolTip="Print To Sign"
      onClick={async () => {
        await printToSign([id]);
      }}
      disabled={isPrinting || !id}
      successTitle="Print to Sign started"
      spinnerDataCy="budget-print-to-sign-spinner"
    />
  );
};

export default PrintBudgetToSign;
